import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

@Injectable({
    providedIn: 'root'
  })
  export class EmailDeliveryReportService{
      constructor(
          private http: HttpClient,
          private apiService: ApiService
      ) { }
      
      public searchEmailDeliveryReport(emailDeliveryReportSearchParam:IGlobalSearchParam):Observable<any> {
        console.log(emailDeliveryReportSearchParam);
        return this.apiService.post(`ReportEmailDelivery/SearchEmailMessageReport`,emailDeliveryReportSearchParam)
      }
      public exportEmailDeliveryReport(emailDeliveryReportSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}ReportEmailDelivery/ExportEmailDelivery`,
        emailDeliveryReportSearchParam ,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
      public searchAnonymousEmailMessageReport(emailDeliveryReportSearchParam:IGlobalSearchParam):Observable<any> {
        console.log(emailDeliveryReportSearchParam);
        return this.apiService.post(`ReportEmailDelivery/SearchAnonymousEmailMessageReport`,emailDeliveryReportSearchParam)
      }
      public exportAnonymousEmailMessageReport(emailDeliveryReportSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}ReportEmailDelivery/ExportAnonymousEmailMessageReport`,
        emailDeliveryReportSearchParam ,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
  }